// FeedbackSlider.jsx
import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay  } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const feedbackSlides = [
  {
    brand: "/images/feedback-brand-white-1.png",
    hoveredBrand: "/images/feedback-brand-white-1.png",
    userImg: "/images/user-img-1.png",
    name: "myteacherlive",
    role: "",
    text: "We've been with Infinitive Host since 2017 and we could never think of moving from them. One of their greatest assets is their support. it's literally amazing and one of the many reasons we couldn't see ourselves moving",
  },
  {
    brand: "/images/feedback-brand-white-1.png",
    hoveredBrand: "/images/feedback-brand-white-1.png",
    userImg: "/images/user-img-3.png",
    name: "Marcuss Rob",
    role: "",
    text: "Good experience to work with infinitivehost. I will always work with infinitivehost. I am using Infinitivehost servers from last 3 years. I have more servers with this company and they manage everything for me perfect."
  },
  {
    brand: "/images/feedback-brand-white-1.png",
    hoveredBrand: "/images/feedback-brand-white-1.png",
    userImg: "/images/user-img-4.png",
    name: "Mostafijur",
    role: "",
    text: "Excellent service and fantastic customer support... As I'm a web developer, was wondering for web hosting solutions for my clients since a long time. I purchased hosting from many well known companies world wide",
  },
  {
    brand: "/images/feedback-brand-2.png",
    hoveredBrand: "/images/feedback-brand-2.png",
    userImg: "/images/user-img-5.png",
    name: "Connect Globes",
    role: "",
    text: "I have a very good experience with Infinitive Host. They have very good customer service which help me a lot about my problem ... love the customer support. Servers are best as per industry norms and almost 100 % uptime.",
  },
  {
    brand: "/images/feedback-brand-2.png",
    hoveredBrand: "/images/feedback-brand-2.png",
    userImg: "/images/user-img-5.png",
    name: "Henry Lee",
    role: "",
    text: "I finally decided to leave Bluehost went with Infinitive Host, I couldn't be happier! The support is amazing, specs are much better than Bluehost & Hostgator. I no longer have to worry about server downtime and lack of support.",
  },
  {
    brand: "/images/feedback-brand-2.png",
    hoveredBrand: "/images/feedback-brand-2.png",
    userImg: "/images/user-img-5.png",
    name: "Bright Livingstone",
    role: "",
    text: "Awesome Support for us. I strongly recommend Infinitive host and team. I knew this company for 3 years and they are fantastic. I have 15 servers with this company and they manage everything for me perfect. No problems",
  },
];

const FeedbackSlider = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  useEffect(() => {
    if (swiperInstance && prevRef.current && nextRef.current) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);

  return (
    <div
      className="mt-8 position-relative"
      data-sal="fade"
      data-sal-duration="1500"
      data-sal-delay="200"
      data-sal-easing="ease-in-out-sine"
    >
        <Swiper
          modules={[Autoplay]}
          spaceBetween={30}
          slidesPerView={3}
          loop={true}
          centeredSlides={true}
          initialSlide={1}
          speed={2500}
          // autoplay={{
          //   delay: 1000,
          //   disableOnInteraction: false,
          // }}
          onSwiper={setSwiperInstance}
          className="feedback-slider"
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            767: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 3,
            },
          }}
        >
        {feedbackSlides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="bg-white p-7 shadow-sm feadback-card">
              <div className="d-flex align-items-center justify-content-between border-bottom border-secondary pb-5">
                <img src={slide.brand} alt="image" className="img-fluid brand" />
                <img src={slide.hoveredBrand} alt="image" className="img-fluid hovered-brand" />
                <i className="fa-solid fa-quote-left quate-icon"></i>
              </div>
              <p className="mt-3">{slide.text}</p>
              <div className="d-flex align-items-center gap-4 mt-7">
                <div className="user-avatar">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8V22h19.2v-2.8c0-3.2-6.4-4.8-9.6-4.8z"/>
                  </svg>
                </div>
                <div>
                  <h6 className="fs-16 mb-0 reviewer-name">{slide.name}</h6>
                  <small>{slide.role}</small>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default FeedbackSlider;
